import { ISearchCustomerItem } from 'modules/customer/widgets/AddCustomer/type';
import { IProductItem } from 'modules/shop/types/product';
import { IStaffItem } from 'modules/shop/types/staff';
import React from 'react';
import { IBillInfoResData } from '../services/types/bill';
import {
  ICashierControllerRef,
  IUIQuickPayChoose,
  IUIWeightChoose,
} from './cashier.interface';
import { IssueFormValues } from './features/SellGift/ModalSelfGift/IssueGiftCard';
import { IProductVIPItemData } from 'modules/shop/types/vip';

export const cashierRef = React.createRef<ICashierControllerRef>();
export const globalCashierDOMRef = React.createRef<HTMLFormElement>();
export type InputSearchProductRef = {
  setForceStop: (value: boolean) => void;
};
export const cashierScannerCtrl = React.createRef<InputSearchProductRef>();
export const cashierCtrl = {
  requestStaffForNewTicket: () =>
    cashierRef.current?.requestStaffForNewTicket(),
  checkStaffExist: (callback: () => void) =>
    cashierRef.current?.checkStaffExist(callback),
  switchTicket: (billId: string) => cashierRef.current?.switchTicket(billId),
  switchTicketWithDetailData: (billData: IBillInfoResData) =>
    cashierRef.current?.switchTicketWithDetailData(billData),
  autoSaveTicket: (_callback: () => void) =>
    cashierRef.current?.autoSaveTicket(_callback),
  saveTicketForPayment: () => cashierRef.current?.saveTicketForPayment(),
  saveTicketPaymentWithCallBack: (_callback: (billId: string) => void) =>
    cashierRef.current?.saveTicketPaymentWithCallBack(_callback),
  checkoutWithBillId: (billId: string, staff: IStaffItem) =>
    cashierRef.current?.checkoutWithBillId(billId, staff),
  checkoutWithDetailData: (billData: IBillInfoResData, staff: IStaffItem) =>
    cashierRef.current?.checkoutWithDetailData(billData, staff),
  generateNewTicket: (staffId?: string) =>
    cashierRef.current?.generateNewTicket(staffId || ''),
  generateNewTicketAfterPayment: (staffId?: string) =>
    cashierRef.current?.generateNewTicketAfterPayment(staffId || ''),
  calculateCashier: () => cashierRef.current?.calculateCashier(),
  syncDraftBill: () => cashierRef.current?.syncDraftBill(),
  chooseCustomer: (customer: ISearchCustomerItem | null) =>
    cashierRef.current?.chooseCustomer(customer),
  chooseProduct: (product: IProductItem) =>
    cashierRef.current?.chooseProduct(product),
  addQuickPayItem: (quickpay: IUIQuickPayChoose) =>
    cashierRef.current?.addQuickPayItem(quickpay),
  addWeightItem: (weight: IUIWeightChoose) =>
    cashierRef.current?.addWeightItem(weight),
  saleGiftCard: (values: IssueFormValues) =>
    cashierRef.current?.saleGiftCard(values),
  saleVIP: (o: IProductVIPItemData) =>
    cashierRef.current?.saleVIP(o),
};
